/**
 * The organisation's name, tagline and mark, wherever they are needed.
 *
 * Backed by the public branding endpoint, so it works on the sign-in screen as well
 * as inside the application. The sign-in screen has nobody signed in, which is the
 * whole reason that endpoint exists.
 *
 * Falls back to the product's own name while the request is in flight and for a
 * profile whose fields are still empty. A sidebar that flashes blank on every load,
 * or reads "" for an organisation that has not filled the form in, would be worse
 * than a sensible default.
 */

import { logoUrl, useBranding } from '@/features/company/api';

import { BRAND } from './brand';

export type Brand = {
  name: string;
  tagline: string;
  /** Absolute URL, or null when no logo has been uploaded. */
  logo: string | null;
};

export function useBrand(): Brand {
  const { data } = useBranding();

  return {
    name: data?.name.trim() ? data.name.trim() : BRAND.name,
    tagline: data?.tagline.trim() ? data.tagline.trim() : BRAND.tagline,
    logo: logoUrl(data),
  };
}
